<template>
  <span @click="editar()">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        > 
        <v-icon :color="color" left>{{ icono }} </v-icon>
        </v-btn>
      </template>      
      <span>{{ tooltip ? $utilidades.traduccion({ texto: tooltip }) : $utilidades.traduccion({ texto: text }) }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: "BtnEditar",
  props: {
    rounded: Boolean,
    text: {
      type: String,
      default: "Editar",
    },
    icono: {
      type: String,
      default: "mdi-pencil",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "success",
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
  components: {},
  methods: {
    editar() {
      this.$emit("editar");
    },
  },
};
</script>